/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.account" placeholder="输入管理者地址"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="adminAddress" label="管理者地址" width="350">
      </el-table-column>
      <el-table-column sortable prop="level" label="权限等级" width="300">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handlePswEdit(scope.$index, scope.row)">修改密码</el-button> -->
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">修改权限</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="管理者地址" prop="account">
          <el-input size="small" v-model="editForm.account" auto-complete="off" placeholder="请输入管理者地址"></el-input>
        </el-form-item>
        <el-form-item label="权限等级" prop="level">
          <el-input size="small" v-model="editForm.level" auto-complete="off" placeholder="请输入等级"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 菜单等级 -->
    <el-dialog title="修改等级" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-form label-width="120px" :model="levelForm" ref="levelForm" :rules="rules">
        <el-form-item label="等级" prop="level">
          <el-input size="small" v-model="levelForm.level" auto-complete="off" placeholder="请输入等级"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="editFormPswVisible" width="30%" @click='closeDialog("showPsw")'>
      <el-form label-width="120px" :model="editPswForm" ref="editPswForm">
        <el-form-item label="密码" prop="level">
          <el-input size="small" v-model="editPswForm.psw" auto-complete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("showPsw")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPswSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleSave,
  roleDelete,
  rolePwd,
  RoleRightTree,
  RoleRightSave
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import md5 from 'js-md5'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      editFormPswVisible:false,
      title: '添加',
      editForm: {
        account: '',
        level: ''
      },
      levelForm: {
        adminId: '',
        level: ''
      },
      editPswForm: {
        adminId: '',
        psw: ''
      },
      // rules 表单验证
      rules: {
        account: [
          { required: true, message: '请输入管理者地址', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请输入管理等级', trigger: 'blur' }
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        account: ''
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取角色列表
    getdata(parameter) {
      this.loading = true
      roleList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
            // if(res.code == 1) {
            //   setTimeout(() => {
            //       this.$store.commit('logout', 'false')
            //       this.$router.push({ path: '/login' })
            //   }, 1000)
            // }
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取角色列表失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
    },
    handlePswEdit(index, row) {
      this.editFormPswVisible = true
      this.editPswForm.adminId = row.id
    },
    // 增加页面保存方法
    submitForm(editData) {
      this.loading = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          roleSave({account:this.editForm.account,level:this.editForm.level})
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.editForm =  {
                  account: '',
                  level: ''
                }
                this.$message({
                  type: 'success',
                  message: '角色添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('角色保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除角色
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          roleSave({adminId:row.id,del:1})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '角色已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 数据权限
    menuAccess: function(index, row) {
      this.menuAccessshow = true 
      this.levelForm.adminId = row.id
      this.levelForm.level = row.level
    },
    // 菜单权限-保存
    menuPermSave() {
      this.loading = true;
      roleSave(this.levelForm)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.menuAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    menuPswSave() {
      this.loading = true;
      roleSave({psw:md5(this.editPswForm.psw),adminId:this.editPswForm.adminId})
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.loading = false
            this.editFormPswVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      } else if(dialog == 'showPsw') {
        this.editFormPswVisible = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/Role.vue